import gql from "graphql-tag";

export const MY_HR_GET_POSTAL_CODES = gql`
  query postalCodes {
    postalCodes {
      code
      name
    }
  }
`;
